import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "greeting" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, " Hello, today is " + _toDisplayString($options.currentMouvDate()) + ", " + _toDisplayString($options.currentElonDate()) + ", " + _toDisplayString($options.currentCantDate()), 1)
  ]))
}